//apis
import { useGetArticles } from 'api/articles/useGetArticles';

//hooks
import { useAddTopSalePost } from 'modules/main/hooks/useAddTopSalePost';
import { useProContext } from 'store/ProReducer/useProContext';
import useDeviceSize from 'utils/hooks/useDeviseSize';
import { useLoadAnchor } from 'utils/hooks/useLoadAnchor';

export const useHomePage = () => {
  const { modulId } = useProContext();

  const deviceSize = useDeviceSize();
  const deviceWidth = deviceSize[0];

  const { pagesArr, anchorRef, isLoading, currentPage } = useLoadAnchor(useGetArticles);

  const { data: { items: topSaleItems = [] } = {}, isLoading: isLoadingTopPosts } =
    useGetArticles({
      topSale: 1,
    });

  const arrayWithTopSalePosts = useAddTopSalePost(pagesArr, topSaleItems);

  return {
    arrayWithTopSalePosts,
    pagesArr,
    anchorRef,
    isLoading,
    isLoadingTopPosts,
    currentPage,
    modulId,
    deviceWidth,
  };
};
